import { Select as AntdSelect } from 'antd';
import { createGuardedComponent } from '../../provider/create-guarded-component';

export type { SelectProps } from 'antd';

export const Select = createGuardedComponent(AntdSelect) as typeof AntdSelect;
